import { ChangeEvent, useCallback, useRef } from 'react';
import useSelectionRef from './useSelectionRef';

interface UseCaretPreservingChangeOptions<
  T extends HTMLInputElement | HTMLTextAreaElement
> {
  onValueChange?: (value: string, event: ChangeEvent<T>) => void;
}

export default <T extends HTMLInputElement | HTMLTextAreaElement>({
  onValueChange,
}: UseCaretPreservingChangeOptions<T>) => {
  const inputRef = useRef<T | null>(null);
  const { captureFromEvent, restoreOnNextTick } = useSelectionRef<T>();

  const handleChange = useCallback(
    (event: ChangeEvent<T>) => {
      const { value } = event.target;

      captureFromEvent(event);

      if (onValueChange) {
        onValueChange(value, event);
      }

      restoreOnNextTick(() => inputRef.current);
    },
    [captureFromEvent, restoreOnNextTick, onValueChange],
  );

  return { inputRef, handleChange };
};
